// bluaIQ — Sentry instrumentation (frontend)
//
// Imported as the first line of src/main.tsx so Sentry is ready before
// React mounts. If VITE_SENTRY_DSN is not set (e.g. local dev without an
// .env.local entry) Sentry stays uninitialized and every SDK call no-ops.
//
// Session Replay is configured to never record normal sessions
// (replaysSessionSampleRate: 0) and to record 100% of sessions that hit
// an error — keeps us inside the free tier while still capturing the
// trace of any session that crashed.

import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
const release = import.meta.env.VITE_SENTRY_RELEASE as string | undefined

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/bluaiq-production\.up\.railway\.app/,
      /^https:\/\/(www\.)?bluaiq\.io/,
      /^https:\/\/blua-iq\.vercel\.app/,
    ],
  })
}

export { Sentry }
